import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { CodeModel } from '../common-code/CommonCode';
import { Group } from '../group/Group';

/**
 * # SimpleUserModel
 * - 사용자 기본 정보 모델
 * - [loginId]: 로그인 아이디
 * - [userNm]: 사용자 이름
 */
const SimpleUserModelProps = {
  loginId: types.string,
  userNm: types.string,
};
export const SimpleUserModel = types.model('User').props(SimpleUserModelProps);

type TSimpleUserType = Instance<typeof SimpleUserModel>;
type TSimpleUserSnapshotType = SnapshotOut<typeof SimpleUserModel>;

export interface ISimpleUser extends TSimpleUserType {}
export type TSimpleUserTypeKey = keyof TSimpleUserSnapshotType & string;
export interface ISimpleUserSnapshot extends TSimpleUserSnapshotType {}

/**
 * # Menu
 * - 메뉴 정보 모델
 * - IMenu type과 동일
 */
const MenuModel = types.model('Menu').props({
  menuSid: types.number,
  menuNm: types.string,
  menuUri: types.string,
  menuTypeCd: types.maybeNull(CodeModel),
  menuPsid: types.maybeNull(types.number),
  ordr: types.number,
});

type TMenuType = Instance<typeof MenuModel>;
type TMenuSnapshotType = SnapshotOut<typeof MenuModel>;

export interface IMenu extends TMenuType {}
export type TMenuTypeKey = keyof TMenuSnapshotType & string;
export interface IMenuSnapshot extends TMenuSnapshotType {}

/**
 * # SimpleUserModel
 * - 사용자 정보 모델
 * - [userSid]: 사용자 고유번호
 * - [loginId]: 로그인 아이디
 * - [userNm]: 사용자 이름
 */
export const createSimpleUser = () =>
  types.optional(SimpleUserModel, {
    userSid: 0,
    loginId: '',
    userNm: '',
  } as TSimpleUserType);

/**
 * # UserModel
 * - 사용자 정보 모델
 */
export const UserModel = types.model('User').props({
  oprtrNm: types.string,
  loginId: types.string,
  pwd: types.maybeNull(types.string),
  beforePwd: types.maybeNull(types.string),
  acntDsabldDt: types.maybeNull(types.number),
  acntLockDt: types.maybeNull(types.number),
  loginFailCnt: types.maybeNull(types.number),
  loginTm1sFailDt: types.maybeNull(types.number),
  acntExpDt: types.maybeNull(types.number),
  wthdYn: types.maybeNull(types.boolean),
  pwdCorrect: types.maybeNull(types.string),
  lastlyPwd: types.maybeNull(types.string),
  oprtrGroupSid: types.maybeNull(types.number),
  oprtrGroupSidList: types.maybeNull(types.array(CodeModel)),
  menuList: types.array(MenuModel),
  allOprtrGroupRoleId: types.maybeNull(types.number),
  oprtrSttsCdList: types.maybeNull(types.array(CodeModel)),
  oprtrGroupList: types.maybeNull(types.array(Group)),
});

type TUserType = Instance<typeof UserModel>;
type TUserSnapshotType = SnapshotOut<typeof UserModel>;

export interface IUser extends TUserType {}
export type TUserTypeKey = keyof TUserSnapshotType & string;
export interface IUserSnapshot extends TUserSnapshotType {}
